// extracted by mini-css-extract-plugin
module.exports = {"container":"legalDocs-module--container--2VFJw","header":"legalDocs-module--header--1PC7w"};